import { FC } from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface PropTypes {
  count?: number;
}

export const MissingMapLocationIndicator: FC<PropTypes> = ({ count }) => {
  const theme = useTheme();
  const tooltip =
    count != null
      ? `${count} missing website map location${count === 1 ? '' : 's'}`
      : 'Missing website map location';

  return (
    <Tooltip title={tooltip}>
      <Stack
        direction="row"
        alignItems="center"
        gap={0.25}
        data-testid="missing-map-location-warning"
        sx={{ flexShrink: 0 }}
      >
        <LocationOnIcon htmlColor={theme.palette.system.amber100} sx={{ fontSize: 14 }} />
        {count != null && (
          <Typography variant="micro" sx={{ color: theme.palette.system.amber100 }}>
            {count}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};
